module.exports = __webpack_public_path__ + "static/media/get-paid-acacia.13b43778.png";